import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import PopupContainer from '../../../common/components/PopupContainer';

export default function CopyrightAlreadyTransferredConfirmPopup({
  onConfirm,
  onCancel,
} : {
  onConfirm: () => void,
  onCancel: () => void,
}) {
  const [agreement, setAgreement] = React.useState(false);
  return (
    <PopupContainer title="※確認※">
      <div className="list__body">
        <p>
          作詞作曲に関わった方からあなたへの著作権譲渡は、書面による契約を行いましたか？
          <br />
          もし書面での契約を行っていない場合、画面を戻って真ん中の選択肢を選んでください。
        </p>
        <p className="top_line" />
        <dl>
          <CustomCheckbox
            checked={agreement}
            setChecked={(checked) => setAgreement(checked)}
          >
            書面での譲渡契約が完了しています。
          </CustomCheckbox>
        </dl>
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onCancel()}>戻る</CustomButton>
            <CustomButton type="default-split" disabled={!agreement} onClick={() => onConfirm()}>次へ</CustomButton>
          </li>
        </ul>
        <span className="b_info">著作権トラブル防止のため、契約書の写しをお送りいただく場合がございます。</span>
      </div>
    </PopupContainer>
  );
}
